<template>
  <section class="user__profile current">
    <Loading
      v-if="isLoading"
      shape="circle"
      :stroke-width="8"
      :size="96"
      rotate
      :indeterminate="true"
    />
    <template v-else>
      <UserProfileCard
        v-if="hasAlias"
        :user="userAlias"
        :heading="$t('headings.PROFILE_ALIAS')"
        :is-blocked="
          Object.keys(userIsBlockedGlobal).length > 0 ||
            Object.keys(aliasIsBlockedGlobal).length > 0
        "
        :is-current-user="true"
        :alias="true"
      />
      <CreateAlias v-else />
    </template>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CreateAlias from "../components/user-profile/CreateAlias";
import Loading from "../components/global/Loading";
import UserProfileCard from "../components/user-profile/UserProfileCard";

export default {
  name: "UserAlias",
  components: {
    CreateAlias,
    Loading,
    UserProfileCard,
  },
  created() {
    this.getMyAlias();
  },
  computed: {
    ...mapGetters([
      "hasAlias",
      "isLoading",
      "myAlias",
      "aliasIsBlockedGlobal",
      "userIsBlockedGlobal",
    ]),
    userAlias() {
      return {
        id: this.myAlias.id,
        name: this.myAlias.name,
        alias: true,
        type: this.$t("headings.PROFILE_ALIAS"),
        picture: this.myAlias.profilePicture,
        rotation: this.myAlias.imageRotation,
        description: this.myAlias.description,
        date: this.myAlias.createdAt,
        comments: this.myAlias.numComments,
        removed: this.myAlias.numRemoved,
      };
    },
  },
  methods: {
    ...mapActions(["getMyAlias"]),
  },
};
</script>
